const isElementInViewport = (el: HTMLElement) => {
    const { top, left, bottom, right }: { top: number; left: number; bottom: number; right: number } = el.getBoundingClientRect();
    const { innerHeight, innerWidth }: { innerHeight: number; innerWidth: number } = window;
    return ((top > 0 && top < innerHeight) || (bottom > 0 && bottom < innerHeight)) && ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth));
};

export default isElementInViewport;
